import React from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import SearchBar from "../components/SearchBar.js";
import SearchContainer from "./SearchContainer.js";
import ProfeCommentsContainer from "./ProfeCommentsContainer.js";
// TODO: Move to here.
import {
  CHANGE_UNIVERSITY,
  CHANGE_QUERY_REQUESTED,
  SEARCH_REQUESTED
} from "../actions.js";
import { SEARCH_PAGE_REGEX } from "../util.js";

import loadingGif from "../assets/images/fruits-apple.gif";
import "font-awesome/css/font-awesome.css";
import "../assets/css/ProfeShop.css";
import "../assets/css/ProfessorPane.css";

class ProfeShop extends React.Component {
  renderLoadingGif() {
    return (
      <div className="container text-center">
        <img src={loadingGif} alt="Loading" />
      </div>
    );
  }
  render() {
    // TODO: Don't render until data is here.
    const universityId = this.props.universityId;
    const query = this.props.query;
    return (
      <div id="ProfeShop" className="container padded page">
        <div className="row">
          <div className="offset-lg-2 col-lg-8">
            <SearchBar
              universityId={universityId}
              data={this.props.data}
              query={query}
              onSelectUniversity={this.props.onSelectUniversity}
              onQueryChange={this.props.onQueryChange}
              onSubmitSearch={this.props.onSubmitSearch}
              inSearchPage={SEARCH_PAGE_REGEX.test(
                this.props.location.pathname
              )}
            />
          </div>
        </div>

        {this.props.isLoading && this.renderLoadingGif()}
        <Route
          exact
          path="/universities/:universityId/search"
          component={SearchContainer}
        />
        <Route
          exact
          path="/universities/:universityId/professors/:professorId"
          component={ProfeCommentsContainer}
        />
      </div>
    );
  }
}

const mapStateToProps = state => state;

// If not inSearchPage, change represents a navigation effectively.
const mapDispatchToProps = dispatch => {
  return {
    onSelectUniversity: (universityId, query, inSearchPage) => {
      if (!inSearchPage) {
        dispatch(push(`/universities/${universityId}/search?q=${query}`));
      } else {
        dispatch({ type: CHANGE_UNIVERSITY, value: universityId });
        dispatch({ type: SEARCH_REQUESTED });
      }
    },
    onQueryChange: (universityId, query, inSearchPage) => {
      if (!inSearchPage) {
        dispatch(push(`/universities/${universityId}/search?q=${query}`));
      } else {
        dispatch({ type: CHANGE_QUERY_REQUESTED, value: query });
      }
    },
    onSubmitSearch: (universityId, query, inSearchPage) => {
      if (!inSearchPage) {
        dispatch(push(`/universities/${universityId}/search?q=${query}`));
      } else {
        dispatch({ type: SEARCH_REQUESTED });
      }
    }
  };
};

const ProfeShopContainer = connect(mapStateToProps, mapDispatchToProps)(
  ProfeShop
);

export default ProfeShopContainer;



// WEBPACK FOOTER //
// ./src/containers/ProfeShopContainer.js